export default __webpack_public_path__ + "static/media/VIU.324818c0.png";